<template><section><h2>Stack Column Chart 堆叠柱状图</h2>
<block-demo tip="" source="const data = [
  {
    data: &quot;05-01&quot;,
    type: &quot;图例一&quot;,
    value: 11,
  },
  {
    data: &quot;05-01&quot;,
    type: &quot;图例二&quot;,
    value: 12.2,
  },
  {
    data: &quot;05-02&quot;,
    type: &quot;图例一&quot;,
    value: 28,
  },
  {
    data: &quot;05-02&quot;,
    type: &quot;图例二&quot;,
    value: 31,
  },
  {
    data: &quot;05-03&quot;,
    type: &quot;图例一&quot;,
    value: 36,
  },
  {
    data: &quot;05-03&quot;,
    type: &quot;图例二&quot;,
    value: 18,
  },
  {
    data: &quot;05-04&quot;,
    type: &quot;图例一&quot;,
    value: 58,
  },
  {
    data: &quot;05-04&quot;,
    type: &quot;图例二&quot;,
    value: 30.2,
  },
  {
    data: &quot;05-05&quot;,
    type: &quot;图例一&quot;,
    value: 86.2,
  },
  {
    data: &quot;05-05&quot;,
    type: &quot;图例二&quot;,
    value: 41.2,
  },
  {
    data: &quot;05-06&quot;,
    type: &quot;图例一&quot;,
    value: 71.2,
  },
  {
    data: &quot;05-06&quot;,
    type: &quot;图例二&quot;,
    value: 45.2,
  },
  {
    data: &quot;05-07&quot;,
    type: &quot;图例一&quot;,
    value: 41.2,
  },
  {
    data: &quot;05-07&quot;,
    type: &quot;图例二&quot;,
    value: 22.2,
  },
  {
    data: &quot;05-08&quot;,
    type: &quot;图例一&quot;,
    value: 16.2,
  },
  {
    data: &quot;05-08&quot;,
    type: &quot;图例二&quot;,
    value: 20.2,
  },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;type&quot;,
  value: &quot;value&quot;,
  text: &quot;data&quot;,
})
const colors = [&quot;#F00&quot;, &quot;#FF0&quot;, &quot;#0FF&quot;]
const bar = new Bar({
  stack: true,
})
const legend = new Legend()
const tooltip = new Tooltip()
const axisBottom = new Axis().style(&quot;grid&quot;, false)
const axisLeft = new Axis({ orient: &quot;left&quot; })
  .style(&quot;axis&quot;, false)
  .style(&quot;scale&quot;, false)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-01"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">11</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-01"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">12.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-02"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">28</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-02"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">31</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-03"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">36</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-03"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">18</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-04"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">58</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-04"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">30.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-05"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">86.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-05"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">41.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-06"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">71.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-06"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">45.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-07"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">41.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-07"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">22.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">16.2</span>,
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">20.2</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"type"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"data"</span>,
})
<span class="hljs-keyword">const</span> colors = [<span class="hljs-string">"#F00"</span>, <span class="hljs-string">"#FF0"</span>, <span class="hljs-string">"#0FF"</span>]
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">stack</span>: <span class="hljs-literal">true</span>,
})
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> })
  .style(<span class="hljs-string">"axis"</span>, <span class="hljs-literal">false</span>)
  .style(<span class="hljs-string">"scale"</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>